//React
import React from "react";
import PropTypes from "prop-types";
//CSS
import "./inputs.scss";

/**
 * Icon-only button (ASB-3953). The shared Button is text-first; this is the
 * primitive for pencils, close X's, save/cancel checks and any other control
 * whose whole face is an icon. Always carries an accessible name via `label`.
 */
function IconButton({ icon, label, onClick, disabled, size, className, type, tabIndex }) {
	const classes = ["icon-button", `icon-button--${size ?? "md"}`, className ?? ""];
	return (
		<button
			type={type ?? "button"}
			className={classes.join(" ").trim()}
			onClick={onClick}
			disabled={disabled ?? false}
			aria-label={label}
			title={label}
			tabIndex={tabIndex}
		>
			<img
				src={icon}
				alt=""
				aria-hidden="true"
			/>
		</button>
	);
}

IconButton.propTypes = {
	/** Imported SVG asset */
	icon: PropTypes.string.isRequired,
	/** Accessible name; also the tooltip */
	label: PropTypes.string.isRequired,
	onClick: PropTypes.func,
	disabled: PropTypes.bool,
	size: PropTypes.oneOf(["sm", "md", "lg"]),
	className: PropTypes.string,
	type: PropTypes.oneOf(["button", "submit"]),
	tabIndex: PropTypes.number,
};

export default IconButton;
